import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'check-in-accordion',
  templateUrl: './checkin-accordion.component.html',
  styleUrls: ['./checkin-accordion.component.scss']
})
export class CheckinAccordionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
